import {MallaPorcentajeModel, SemanaModel} from '../../FriedmanModule/models/semana.model';
import * as moment from 'moment';

export class SemanaReporteModel {
  nombre:string = "";
  idTienda:string = "";
  semanas:SemanaModel[] = [];
  ventas:any[] = [];

  meta:number = 0;
  minimo:number = 0;
  venta:number = 0;
  artTicket:number = 0;
  ticketPromedio:number = 0;
  cumplimiento:number = 0;
  friedman:number = 0;

  dataGraficas: any = {};
  view:any[] = [900,600];

  // options
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = true;
  showXAxisLabel = false;

  showYAxisLabel = true;
  yAxisLabel = 'En Pesos';
  timeline = true;

  colorScheme = {
    domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA']
  };

  addSemanaReporte(data:any){
    let sem = SemanaModel.CrearSemana(data);

    this.semanas.push(sem);
  }

  agregarVentas(ventas:any[]){
    for(let v of ventas)
      this.ventas.push(v);
  }

  calcularIndicadores(fecha1:any, fecha2:any){
    this.meta = 0;
    for(let s of this.semanas){
      for(let md of s.mPorcentaje.dias){
        let f = moment(md.fecha);
        if(moment(f).isBetween(fecha1, fecha2,undefined,"[]"))
          this.meta += md.precio
      }
    }
    this.minimo = this.meta *.9;

    this.venta = 0;
    this.artTicket = 0;
    this.ventas.map(v=>{
      this.venta += v.cantidad;
      this.artTicket += v.articulos.length;
    })

    if(this.artTicket > 0)
      this.artTicket /= this.ventas.length;

    if(this.venta > 0)
      this.ticketPromedio = this.venta / this.ventas.length;

    this.cumplimiento = this.venta / this.meta * 100;

    if (this.cumplimiento <= 89.99)
      this.friedman = 0;
    else if (this.cumplimiento <= 99.99)
      this.friedman = 1;
    else if (this.cumplimiento <= 109.99)
      this.friedman = 2;
    else
      this.friedman = 3;



    this.dataGraficas = [
      {
        'name': 'Presupuesto',
        'value': this.meta
      },
      // {
      //   'name': 'Minimo',
      //   'value': this.minimo
      // },
      {
        'name': 'Ventas Actuales',
        'value': this.venta
      }
    ]

  }
}
